import axios from 'axios';
import { getPurchaseDetailsRequestBody } from '../../../selectors/kaMetlhaFuneralCover/quote';
import { setKmfApiDetails, setKmfApplicationApiStatus, setPurchaseServiceResponse } from '../../../actions/kaMetlhaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../../../reducers/status';
import { navigateNext, navigateToThankYou } from '../../../actions/kaMetlhaFuneralCover/routing';
import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import { sendPurchaseEmailCustomer } from '../../../actions/kaMetlhaFuneralCover/policyRequest';

export const purchaseService = (store, next, action) => {
    const state=store.getState();
    (async () => {
        try{
            
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.PENDING,name:'purchaseService'}));
            const sampleRequestBody= getPurchaseDetailsRequestBody(state)
            const response = await sendPurchaseDetails(sampleRequestBody);
        if (response && response.status === httpStatusCode.OK) {
            // store.dispatch(setAllsureApplicationQuoteDetails(response.data));
            store.dispatch(setPurchaseServiceResponse(response?.data))
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.SUCCESS,name:'purchaseService'}));
            store.dispatch(sendPurchaseEmailCustomer(response?.data))
            store.dispatch(navigateToThankYou())
        } else {            
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'purchaseService',content:response?.response?.data?.data?.message??null}));
        }
    }
        catch(error){
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'purchaseService'}));
        }
    })();
    return next(action);
};

const sendPurchaseDetails = async (requestBody)=>{
        try {
            // /om-api/ka-metlha-funeral/sendPurchaseDetails
            const response = await axios({
                url: '/om-api/ka-metlha-funeral/sendPurchaseDetails',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                data: requestBody,
            });
            return response;
        } catch (error) {
            return error;
        }
}
